import styles from "./SearchCrawlerMonitoring.module.css";
import { useState, useEffect, useCallback } from "react";
import { getSearchCrawlMonitoring } from "../../../api/portalApi";
import AGTable from "../../../components/AGTable/AGTable";
import { Button, Spinner, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

const SearchCrawlerMonitoring = (props) => {
    // Data States
    const [monitoringData, setMonitoringData] = useState();
    const [detailedJob, setDetailedJob] = useState();

    // UI States
    const [loading, setLoading] = useState(false);

    // Fetch Data from API
    const fetchData = useCallback( async() => {
        setLoading(true);
        try {
            const res = await getSearchCrawlMonitoring();
            setMonitoringData(res?.data?.data || res?.data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }

    }, []);

    useEffect(() => { 
        fetchData();
    }, [fetchData]);


    let flattenedData;
    if (monitoringData){
        flattenedData = monitoringData?.map(obj => {

            let tempObj = Object.fromEntries(
                Object.entries(obj).map(([key, value]) => [
                    key,
                    Array.isArray(value) ? value.join(", ") : value
                ])
            );
            tempObj["link"] = ((obj?.status === 'Ready to Review' || obj?.status === 'Review in Progress' || obj?.status === 'Review Complete') && (obj?.matches_found !== "" || obj?.matches_found === 0) )  ? (
            <Link 
                to="/search-crawler/match-review"
                state={{locationJobid: tempObj["job_id"], userEmail: props?.userEmail}}
            >
                Go to Results
            </Link>) : "";
            tempObj["detailed"] = <div>

            <Button variant="success" size="sm" onClick={() => setDetailedJob({...tempObj})}>
                View Detailed
            </Button>
            </div>
            return {
                ...tempObj,
                job_id: (tempObj?.match_source !== "manual_upload")  ? (<a href={"https://app.zyte.com/p/" + tempObj?.job_id} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2' }}>
                    {tempObj?.job_id}
                  </a>) : tempObj?.job_id
            };
        }
        );

    }
    const conditionalRules = [
        {
            column: ["status"],
            rules: {
                "cell-success": params => params.value === "Job Finished" || params.value === "Review Complete",
                "cell-warning": params => params.value === "Job Running" || params.value === "Review in Progress",
                "cell-orange": params => params.value === "Ready to Review",
                "cell-fail": params => params.value !== "Job Running" || params.value !== "Job Finished" || params.value !== "Review in Progress" || params.value === "Review Complete",
            }
        }
    ]
    // console.log("detailedJob: ", detailedJob);
    return (
        <div>
            <Modal show={detailedJob}>
                <Modal.Header closeButton onClick={() => setDetailedJob()}>
                    <Modal.Title>Details for Job {detailedJob?.job_id}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.MonitoringModalBody}>
                        <span><strong>Job ID:</strong> {detailedJob?.job_id}</span>
                        <span><strong>Vertical:</strong> {detailedJob?.vertical}</span>
                        <span><strong>Search Banner:</strong> {detailedJob?.search_banner}</span>
                        <span><strong>Result Banner:</strong> {detailedJob?.result_banner}</span>
                        <span><strong>Match Source:</strong> {detailedJob?.match_source}</span>
                        <span><strong>Number of Matches Found:</strong> {detailedJob?.matches_found}</span>
                        <span><strong>Number of Matches Approved:</strong> {detailedJob?.approved} ({(parseFloat(parseInt(detailedJob?.approved)/parseInt(detailedJob?.matches_found))* 100).toFixed(2) }%) </span>
                        <span><strong>Number of Matches Rejected:</strong> {detailedJob?.rejected} ({(parseFloat(parseInt(detailedJob?.rejected)/parseInt(detailedJob?.matches_found))* 100).toFixed(2) }%) </span>
                        <span><strong>Number of Matches Pending Review:</strong> {detailedJob?.pending} ({(parseFloat(parseInt(detailedJob?.pending)/parseInt(detailedJob?.matches_found))* 100).toFixed(2) }%) </span>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => setDetailedJob()}>
                    Close
                </Button>
                <Link 
                    to="/search-crawler/match-review"
                    state={{locationJobid: detailedJob?.job_id, userEmail: props?.userEmail}}
                >
                    <Button variant="success">
                        Go To Results
                    </Button>
                </Link>
                </Modal.Footer>
            </Modal>
            <div className={styles.SearchCrawlerMonitoring}> 
                <h4>Search Crawl Monitoring</h4>
                {flattenedData && <AGTable data={flattenedData} conditionalRules={conditionalRules} columnsToHide={["job_started_ts", "approved", "rejected", "pending", "zyte_url"]} fileName="search_crawl_monitoring.csv"/>}
                {loading && <div className={styles.spinnerContainer}>
                    <Spinner/>
                </div>}
            </div>
        </div>
    )
};

export default SearchCrawlerMonitoring;